import { render, staticRenderFns } from "./backToTop.vue?vue&type=template&id=3d34dcea&scoped=true"
import script from "./backToTop.vue?vue&type=script&lang=js"
export * from "./backToTop.vue?vue&type=script&lang=js"
import style0 from "./backToTop.vue?vue&type=style&index=0&id=3d34dcea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d34dcea",
  null
  
)

export default component.exports